<template>
    <div class="columns is-multiline">
        <div class="column is-half">
            <article class="panel is-warning">
                <b-loading :is-full-page="false" :active.sync="loadingA" :can-cancel="true"></b-loading>
                <div class="panel-heading">
                    <p class="heading">Ordenes para validar</p>
                    <p class="title has-text-white">UY$ {{orderAsum}}</p>
                </div>
                <a :href="'/order/detail/?order_pk='+ord.id" v-for="ord in orderA" :key="ord.id" class="panel-block">
                    <p>
                        {{ord.orderdata.email}} 
                        <span class="tag is-success is-rounded">UY${{ord.payment.amountUy}}</span>
                        <span class="tag is-info is-rounded m-l-5">
                            {{ new Date(ord.timestamp).toLocaleDateString() }}
                        </span>
                    </p> 
                </a>
            </article>
        </div>
        <div class="column is-half">
            <article class="panel is-info">
                <b-loading :is-full-page="false" :active.sync="loadingP" :can-cancel="true"></b-loading>
                <div class="panel-heading">
                    <p class="heading">Ordenes pendientes de pago</p>
                    <p class="title has-text-white">UY$ {{orderPsum}}</p>
                </div>
                <a :href="'/order/detail/?order_pk='+ord.id" v-for="ord in orderP" :key="ord.id" class="panel-block">
                    <p>
                        {{ord.orderdata.email}} 
                        <span class=" tag is-success is-rounded">UY${{ord.payment.amountUy}}</span>
                        <span class="tag is-info is-rounded m-l-5">
                            {{ new Date(ord.timestamp).toLocaleDateString() }}
                        </span>
                    </p> 
                </a>
            </article>
        </div>
    </div>
</template>

<script>
import { getHandler } from '../../../../services/http'
export default {
    props:{
        ordersApproval:{
            type:String,
            default:""
        },
        ordersPending:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            orderA:[],
            orderAsum:0,
            orderP:[],
            orderPsum:0,
            loadingA:false,
            loadingP:false
        }
    },
    methods:{
        async fetchApprovalNeeded(){
            this.loadingA = true
            this.orderA = await getHandler(this.ordersApproval, {error:false, success:false})
            this.loadingA = false
        },
        async fetchPending(){
            this.loadingP = true
            this.orderP = await getHandler(this.ordersPending, {error:false, success:false})
            this.loadingP = false
        },
    },
    created(){
        this.fetchApprovalNeeded()
        this.fetchPending()
    },
    watch:{
        orderA: function(val){
            var sum = 0
            for (var i in this.orderA){
                sum = sum + parseInt(this.orderA[i].payment.amountUy)
            }
            this.orderAsum = sum
        },
        orderP: function(val){
            var sum = 0
            for (var i in this.orderP){
                console.log(this.orderP[i])
                sum = sum + parseInt(this.orderP[i].payment.amountUy)
            }
            this.orderPsum = sum
        }
    }
}
</script>

<style lang="scss" scoped>
.panel-heading{
    background:hsl(217, 71%, 53%);
    color: #fff;
}

</style>